<template>
  <l-feature-group name="us-states">
    <l-geo-json
      :geojson="usStates"
      :options="usStatesOptions"
      :options-style="usStatesStyle"
      />
    <l-feature-group name="us-states-wrapped" v-if="wrappedMarkers">
      <l-geo-json
        :geojson="usStates"
        :options="usStatesOptionsLeft"
        :options-style="usStatesStyle"
        />
      
      <l-geo-json
        :geojson="usStates"
        :options="usStatesOptionsRight"
        :options-style="usStatesStyle"
        />
    </l-feature-group>
  </l-feature-group>
</template>

<script>
  console.log("import usStatesData started")
  import usStatesData from '@/assets/json-files/gz_2010_us_040_00_5m.json'

  export default {
    props: ['wrappedMarkers', 'usStatesOptions', 'usStatesOptionsLeft', 'usStatesOptionsRight', 'usStatesStyle'],
    data: function() {
      console.log("usStatesData import finished")
      return {
        usStates: usStatesData,
      }
    }
  }
</script>
